<template>
  <button class="btn c-btn-default" @click="emitShowQuestionnaire">{{ button.description }}</button>
</template>

<script>
import QuestionnaireEntity from "../../../../../common/js/entity/questionnaireEntity"

export default {
  name: "QuestionnaireActiveButton",
  props: {
    questionnaire: {
      type: QuestionnaireEntity,
      required: true
    }
  },
  data() {
    return {
      button: this.questionnaire.activeButton
    }
  },
  methods: {
    emitShowQuestionnaire() {
      const questionnaire = this.questionnaire
      questionnaire.show()

      this.$emit("show-questionnaire", questionnaire)
    }
  }
}
</script>
